<nz-table
  #pocTable
  [nzBordered]="false"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
  [nzScroll]="{ x: '600px', y: '200px' }"
  [nzSize]="'small'"
  [nzData]="pocList"
  class="table-shadow"
>
  <thead>
    <tr>
      <th nzWidth="20%">Type</th>
      <th nzWidth="30%">Name</th>
      <th nzWidth="30%">Email</th>
      <th nzWidth="20%" nzAlign="center">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let poc of pocList; let i = index">
      <td>
        <ng-container *ngIf="poc?.is_primary; else setPrimaryPOC">
          <nz-tag [nzColor]="'#87d068'">Primary</nz-tag>
        </ng-container>
        <ng-template #setPrimaryPOC>
          <nz-tag
            nzMode="checkable"
            (nzCheckedChange)="setPrimaryPOCDetail($event, poc)"
          >
            Set Primary
          </nz-tag>
        </ng-template>
      </td>

      <td style="font-weight: bold">
        <span
          nz-tooltip
          [nzTooltipTitle]="poc?.name"
          (click)="openPOCModal(poc)"
          style="cursor: pointer; color: #4500a4"
        >
          {{ poc?.name }}
        </span>
      </td>

      <td>
        <span nz-tooltip [nzTooltipTitle]="poc?.email">
          {{ poc?.email }}
        </span>
      </td>

      <td nzAlign="center">
        <button
          nz-button
          nzType="text"
          nzSize="small"
          nz-tooltip
          [nzTooltipTitle]="'Edit'"
          nzTooltipPlacement="top"
          (click)="editPOC(poc)"
        >
          <nz-icon nzType="edit" nzTheme="outline" />
        </button>

        <button
          nz-button
          nzType="text"
          nzDanger
          nzSize="small"
          nz-tooltip
          [nzTooltipTitle]="'Delete'"
          nzTooltipPlacement="top"
          [nz-popconfirm]="deletePOCPopconfirm"
          [nzPopconfirmTitle]="''"
          [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deletePOC(poc)"
        >
          <nz-icon nzType="delete" nzTheme="outline" />
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>

<ng-template #deletePOCPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this POC?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
  <!-- <div class="custom-popconfirm-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
    <button nz-button nzType="default" nzSize="small" (click)="$event.stopPropagation(); deletePOCPopconfirm.cancel()">Cancel</button>
    <button nz-button nzType="primary" nzDanger nzSize="small" (click)="$event.stopPropagation(); deletePOCPopconfirm.confirm()">OK</button>
  </div> -->
</ng-template>
